import { decimalSeparator } from './decimal-separator';

export function amoutStrToBaseUnitQuantity({
  amountStr,
}: {
  amountStr: string;
}): number {
  const [integerPart, decimalPart] = amountStr.split(decimalSeparator);

  const baseUnitQuantityString =
    integerPart + decimalPart.slice(0, 2).padStart(2, '0');

  const baseUnitQuantity = parseInt(baseUnitQuantityString);

  return baseUnitQuantity;
}
